import { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import image1 from "../../asset/Sales/image1.svg";
import image2 from "../../asset/Sales/image2.svg";
import image3 from "../../asset/Sales/image3.svg";
import image4 from "../../asset/Sales/image4.svg"
import arrow from "../../asset/Sales/arraow.svg";

const ITEMS = [
  {
    id: "01",
    title: "Clone Your Best Closer",
    desc: "Founder-level answers, on every rep's screen, every call.",
    image: image1,
  },
  {
    id: "02",
    title: "Chase the Right Leads First",
    desc: "AI-read intent tags every lead Hot, Warm, or Cold",
    image: image2,
  },
  {
    id: "03",
    title: "Increase Sales Productivity",
    desc: "Reduce time spent documenting meetings and preparing follow-ups",
    image: image4,
  },
    {
    id: "04",
    title: "Accelerate Deal Progression",
    desc: "Ensure every conversation results in clear next steps and follow-up actions.",
    image: image3,
  },
];

export default function BusinessImpact() {
  const [active, setActive] = useState(0);
const sectionRef = useRef(null);
const isAnimating = useRef(false);

useEffect(() => {
  const section = sectionRef.current;

  if (!section) return;

 const handleWheel = (e) => {
  const rect = section.getBoundingClientRect();

  const inView =
    rect.top <= 0 &&
    rect.bottom >= window.innerHeight;

  if (!inView) return;

  if (isAnimating.current) {
    e.preventDefault();
    return;
  }

  // Scroll Down
  if (e.deltaY > 20) {

    if (active < ITEMS.length - 1) {
      e.preventDefault();

      isAnimating.current = true;

      setActive((v) => v + 1);

      setTimeout(() => {
        isAnimating.current = false;
      }, 600);

      return;
    }

    // Last step reached
    // Don't prevent default
    return;
  }

  // Scroll Up
  if (e.deltaY < -20) {

    if (active > 0) {
      e.preventDefault();

      isAnimating.current = true;

      setActive((v) => v - 1);

      setTimeout(() => {
        isAnimating.current = false;
      }, 600);

      return;
    }

    // First step
    // Allow page to scroll upward
  }
};

  window.addEventListener("wheel", handleWheel, {
    passive: false,
  });

  return () =>
    window.removeEventListener("wheel", handleWheel);
}, [active]);

  const current = useMemo(() => ITEMS[active], [active]);
  const visibleItems = [
  ITEMS[(active + ITEMS.length - 1) % ITEMS.length], // previous
  ITEMS[active],                                     // active
  ITEMS[(active + 1) % ITEMS.length],                // next
];
  return (
<section
  ref={sectionRef}
  className="relative h-[250vh] md:h-[300vh] lg:h-[300vh] bg-white mb-10 mt-15 md:mt-0 md:mb-0 lg:mt-20 lg:mb-20 "
>
  {/* Mobile Heading */}
<div
  className="
    md:hidden

    text-center
    max-w-4xl
    mx-auto

    px-4
    mb-10
  "
  style={{ zoom: "0.8" }}
>
  <span className="inline-flex mb-5 px-4 py-1 rounded-md bg-[#FFE9E4] text-[#EB604A] font-prompt font-semibold text-[17px]">
    Business Impact
  </span>

  <h2 className="mt-5 text-[#45453D] font-prompt font-bold text-[20px]">
    Turn Every Sales Conversation Into Revenue
  </h2>

  <p className="mt-4 text-[16px] text-[#0C0200] font-jakarta">
    Sales AI empowers sales teams to focus on meaningful customer conversations with real-time AI guidance, helping every rep build confidence, overcome objections, and close more deals.
  </p>
</div>
  <div className="sticky top-0 h-screen flex items-center">
    <div
      className="w-full py-16 mb-5 md:py-2 lg:py-24 px-4 lg:px-16"
      style={{ zoom: "0.75" }}
    >
      <div className="max-w-[1380px] mx-auto">
<div className="hidden md:block md:mt-0 lg:mt-20 text-center max-w-4xl mx-auto">
            <span className="inline-flex mb-5 px-4 py-1 rounded-md bg-[#FFE9E4] text-[#EB604A] font-prompt font-semibold text-[17px]">
            Business Impact
          </span>
          <h2 className="mt-5 text-[#45453D] font-prompt font-bold text-[20px] lg:text-[48px] md:text-5xl">
            Turn Every Sales Conversation Into Revenue
          </h2>
          <p className="mt-4 text-[16px] md:text-[18px] lg:text-[20px] text-[#0C0200] font-jakarta">
            Sales AI empowers sales teams to focus on meaningful customer conversations with real-time AI guidance, helping every rep build confidence, overcome objections, and close more deals.
          </p>
        </div>
        <div className="mt-14 border border-[#F4B4A8] rounded-2xl overflow-hidden">
          <div className="grid lg:grid-cols-[46%_54%] md:grid-cols-[46%_54%]">
<div
  className="
    relative

    h-[350px]
    md:h-[470px]
    lg:h-[580px]

    flex
    items-center
    overflow-hidden
  "
>
 <div
className="
absolute

-left-[185px]
md:-left-[340px]
lg:-left-[400px]

top-[20px]
md:top-[10px]
lg:-top-[10px]

w-[300px]
h-[300px]

md:w-[470px]
md:h-[490px]

lg:w-[560px]
lg:h-[600px]

rounded-full
bg-[#EB604A]
"
/>

  {/* Inner Cut */}
<div
 className="
absolute

-left-[165px]
md:-left-[315px]
lg:-left-[360px]

top-[60px]
md:top-[82px]
lg:top-[80px]

w-[220px]
h-[220px]

md:w-[360px]
md:h-[340px]

lg:w-[420px]
lg:h-[425px]

rounded-full
bg-white
"
/>
     <div
  className="
    absolute
    left-[70px]
md:left-[62px]
lg:left-[95px]
    lg:top-1/2
    md:top-1/2
    top-[170px]
    -translate-y-1/2

    z-20
  "
>
  <AnimatePresence mode="wait">
    <motion.div
      key={active}
      initial={{ y: 30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -30, opacity: 0 }}
      transition={{
        duration: 0.50,
        ease: "easeInOut",
      }}
      className="flex flex-col items-center gap-2"
    >
      {visibleItems.map((item, index) => (
        <button
          key={item.id}
          className={`
            h-[34px]
            flex
            items-center
            justify-center

           text-[18px]
md:text-[22px]
lg:text-[30px]

            font-bold
            font-jakarta
            transition-all
            duration-300

            ${
              index === 1
                ? "text-white scale-110"
                : "text-[#FFB4A7]"
            }
          `}
        >
          {item.id}
        </button>
      ))}
    </motion.div>
  </AnimatePresence>
</div>
           
              <div className="ml-[80px]
md:ml-[110px]
lg:ml-[140px] flex items-center gap-6">

  {/* Arrow */}
  <img
    src={arrow}
    alt=""
    className="
     w-16
md:w-10
lg:w-20

      shrink-0
    "
  />

  {/* Text */}
  <motion.div
    key={active + "t"}
    initial={{ opacity: 0, x: 25 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.45 }}
  >
    <h3 className="text-lg
md:text-2xl
lg:text-3xl font-jakarta font-bold text-[#45453D]">
      {current.title}
    </h3>

    <p className="mt-3 text-[#666] font-jakarta text-[12px]
md:text-[16px]
lg:text-[18px]

leading-6
lg:leading-8

max-w-[240px]
md:max-w-[320px]
lg:max-w-[420px] ">
      {current.desc}
    </p>
  </motion.div>

</div>
            </div>
           <div
  className="
 
  md:mt-20
  lg:mt-5
    p-4
    md:p-5
    lg:p-8
  "
>
<div
  className="
    border
    border-dashed
    border-[#F4B4A8]

    rounded-md

    p-2
    md:p-3
    lg:p-4
  "
>                <AnimatePresence mode="wait">
                  <motion.img
                    key={active}
                    src={current.image}
                    className="
w-full
h-auto
object-contain
"
                    initial={{ opacity: 0, x: 60 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -60 }}
                    transition={{ duration: 0.5 }}
                  />
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </div>
    
</div>
</div>

    </section>
  );
}
